import { BlockType, TextType } from '@next-space/fe-api-idl';
import { newContent, newElement } from '@next-space/fe-inlined/utils';
import { getEditorModelByEditorKey } from 'src/editor/editor/uikit/editable-models';
import { addBlock } from 'src/redux/managers/block/add';
import { checkPageId } from '../../check-page-id';
import type { PasteHook } from '../types';
import { common } from './common';

const INLINE_MENTION_BLOCK_TAG = 'inline-mention-block';

export const pasteAnnotation = async (
  { transaction }: PasteHook,
  annotationId: string,
  type?: string
) => {
  const { pos, posEditorKey, pageId } = common();
  const blockData = await checkPageId(annotationId);

  if (blockData.code !== 200) {
    return;
  }

  if (!pos) return;

  const model = getEditorModelByEditorKey(posEditorKey || pos);
  const { selection } = model;
  if (!selection) return;

  if (model) {
    if (type === 'imageBlock') {
      // 图片块
      transaction(() => {
        addBlock(
          {
            type: BlockType.REFERENCE,
            data: {
              ref: { uuid: annotationId },
              display: 'image',
              segments: [{ enhancer: {}, text: '图片标注.png', type: TextType.TEXT }],
            },
          },
          { parentId: pageId, after: pos }
        );
      });
    } else {
      model.performChange((ctx) => {
        ctx
          .select(selection.offset, selection.endOffset)
          .replace(
            newContent([
              newElement(INLINE_MENTION_BLOCK_TAG, {
                pageId: blockData.data.parentId,
                blockId: annotationId,
              }),
            ])
          )
          .collapse('end');
      });
    }
  }
};
